export const INTEGRATIONS_API_URL =
  import.meta.env.VITE_INTEGRATIONS_GRAPHQL_URL || 'https://api-integrations.butlr.io/graphql';

export const INTEGRATIONS_REPORTING_API_URL =
  import.meta.env.VITE_INTEGRATIONS_REPORTING_API_URL ||
  'https://api-integrations.butlr.io/api/v1/reporting';

/** Maps a Redux interval value (seconds) to the closest Reporting API interval string. */
export function toReportingApiInterval(intervalSeconds: number): string {
  if (intervalSeconds >= 86400) return '1d';
  if (intervalSeconds >= 3600) return '1h';
  if (intervalSeconds >= 1800) return '30m';
  if (intervalSeconds >= 900) return '15m';
  return '1m';
}
